import React from 'react'
import styled from 'styled-components';
import Button from '../Button';
import { motion} from 'framer-motion';


const Hero = () => {
  return (
   <>
   <Herosection className='flex j-center'>
    <div className="hero-content flex j-center">
        
    <div className="hero-welcome">
    <video src='./images/me.mp4' muted autoPlay loop  className="custom-video"  />
        {/* <div className="circle flex center">
            <img src="./images/hello.gif" alt="" className="hello" />
            </div> */}
        </div>
       <motion.h2
       initial={{x:-100}}
       animate={{x:0}}>
        Hulesh Jangde
       </motion.h2>
       <p className="hero-intro">
       A Frontend focused Web Developer building the Frontend of Websites and Web Applications that leads to the success of the overall product
       </p>
       <div className="buttons flex">
        <Button go="/contact" text="Chat Now" icon="./images/icons/message.png"/>
        <Button go="/contact" text="Hire Me" icon="./images/icons/user.png"/>
       </div>


    </div>
   </Herosection>
   </>
  )

}
const Herosection =styled.section`
/* background-image: url(./images/bgimg.png); */
/* transform: rotate(2deg); */
@media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
  height: 100vh;
   
}
flex-direction: column;
     width: 100%;
     height: 95vh;

    color: white;
    .hero-content{
        display: flex;
       align-items: center;
       text-align: center;
        flex-direction: column;
       gap: 10px;
       @keyframes bgAnimation {
    0% {
      background-color: #FB315A;
    }
    50% {
      background-color: #FFB238;
    }
    100% {
      background-color: #46BFB0;
    }
  }
       @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   gap: 30px;
   
   
}
       @media (max-width: 480px) {
          justify-content : space-between;
          gap: 25px;
         
        }
       .buttons{
        gap: 15px;
        margin-top: 15px;
       }
    }
    .hero-content h2{
        font-size: 4.5rem;
        color: #FB315A;
        font-family: 'Berkshire Swash', cursive;
        text-shadow: 2px 7px 5px #a41c5ba1, 
    0px -4px 10px #877e8349;
    /* For Tablet View */
@media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
 font-size: 6rem;
}
    @media (max-width: 480px){
        font-size: 2.8rem;
    }
    }
    .hero-content p{
        width: 40%;
        font-size: 0.8rem;
        font-weight: 300;
        margin-top: 10px;
        font-family: 'Fira Code', monospace;
        color: #ffffffaf;
        /* For Tablet View */
@media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
      font-size: 1.5rem;
      width: 100%;
      padding: 0 15px;
}
        @media (max-width: 480px){
      width: 100%;
      font-size: 1.4rem;
      padding: 0 10px;
    }

    }
    .circle{
        width: 250px;
        height: 250px;
        backdrop-filter: blur(25px);
        background-color: #cbebf29c;
        justify-content: center;
        border-radius: 50%;
          /* For Tablet View */
@media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
    width: 450px;
        height: 450px;
   
}
        
    }
    .custom-video {
  width: auto;
  height: 400px;
  border-radius: 30px;

  @media (max-width: 480px) {
          height: 300px;
  }

}
    .hero-welcome img{
        width: 200px;
        height: 200px;
        border-radius: 50%;
        @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
    width: 350px;
        height: 350px;
   
}
    }
   
    @media (max-width: 480px) {
           width: 100%;
           height: 100vh;
         padding:0;  
         
      

  @keyframes bgAnimation {
    0% {
      background-color: #FB315A;
    }
    50% {
      background-color: #FFB238;
    }
    100% {
      background-color: #46BFB0;
    }
  }
        }
`



export default Hero